import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export const authGuard = async (): Promise<boolean> => {
  const authService = inject(AuthService);

  try {
    const isAuthenticated: boolean = await authService.isAuthenticated();
    if (isAuthenticated) {
      return true;
    }

    authService.login();
    return false;
  } catch (error) {
    authService.login();
    return false;
  }
};
